import type { KeyboardEvent, RefObject } from 'react';

/**
 * A pop-up's own Escape, for the keydown of the pop-up itself: closes it and hands the focus back
 * to the button that opened it. Without it the focus was on a control of the pop-up, which Escape
 * unmounted, and fell to <body> — a keyboard user restarted from the top of the page.
 *
 * Stopped where it happens: the pop-up is what Escape closes, not a dialog it sits in. useDismiss
 * still closes it on a click outside, where the focus belongs where the pointer put it.
 */
export function escapeToTrigger(close: () => void, trigger: RefObject<HTMLElement>) {
  return (e: KeyboardEvent<HTMLElement>) => {
    if (e.key !== 'Escape') return false;
    e.preventDefault();
    e.stopPropagation();
    close();
    trigger.current?.focus();
    return true;
  };
}
